import { mergeTypeDefs } from '@graphql-tools/merge';
import schema from './schema.graphql';

export const typeDefs = mergeTypeDefs([schema]);
